export enum FileType {
  DEFAULT = '*/*',
  IMAGE = 'image/*',
  // Add more file types as needed
}
